import { isFunction, isNumber } from '@agilepoint/utils-common';
import * as React from 'react';
import styled from 'styled-components';
import { Textbox, ITextboxProps } from '../../textbox';
import { useChooseRef } from '../../../utils';
import { SourceOfChange } from '../numeric-box-props';

interface INumericFieldProps extends ITextboxProps {
    spinnerInView?: boolean;
    value: string;
    decimalChar: string;
    changeValue(isIncrement: boolean, sourceOfChange: SourceOfChange): void;
}

enum KeysToListen {
    arrowDown = 'ArrowDown',
    arrowUp = 'ArrowUp'
}

function isValidEntry(ev: React.KeyboardEvent<HTMLInputElement>, decimalChar: string): boolean {
    const { target: { value }, key, location } = (ev as any);
    if (!value.length) {
        return key === '-' || isNumber(Number(key));
    }
    if (value[0] !== '-' && location === 0 && key === '-') {
        return true;
    }
    if (key === decimalChar) {
        return isNumber(Number(value + '.'));
    }
    return isNumber(Number(key));
}

function NumericFieldBase(props: INumericFieldProps) {
    const { elementRef, onKeyDown, changeValue, decimalChar, ...rest } = props;
    const numberFieldRef = useChooseRef<HTMLInputElement>(elementRef);

    const _onKeyDown = React.useCallback((e: React.KeyboardEvent<HTMLInputElement>) => {
        const key = e.key;

        switch (key) {
            case KeysToListen.arrowUp:
                e.preventDefault();
                changeValue(true, 'input');
                break;
            case KeysToListen.arrowDown:
                e.preventDefault();
                changeValue(false, 'input');
                break;
            default: break;
        }
        if ((key.length === 1 && !isValidEntry(e, decimalChar)) || key === 'Space') {
            e.preventDefault();
        }
        if (isFunction(onKeyDown)) {
            onKeyDown(e);
        }
    }, [changeValue, decimalChar, onKeyDown]);

    return (
        <Textbox {...rest}
            elementRef={numberFieldRef}
            onKeyDown={_onKeyDown}
        />
    );
}

export const NumericField = styled(NumericFieldBase).attrs(() => ({
    className: String('ap-numericBox')
}))`
    width: 100%;
    padding: ${({ spinnerInView, theme: { semantics: { gap } } }) => `0 ${spinnerInView ? gap.xl : '38px'} 0 ${gap.xl}`};
`;
